import z from 'zod';

export type ValidationFormSchemaValues = z.infer<typeof validationFormSchema>;
export const validationFormSchema = z.object({
    validator_account: z.string(),
    type: z.string().min(1),
    active_stay_period: z.string().nullish(),
    past_stay_period: z.string().nullish(),

    // Just so we can display the visitor in the form
    visitor: z.string().nullish(),
});
